/* Payal Jewellers — app-free wishlist (localStorage).
   Stores product handles; renders the wishlist page by fetching each
   product's card via an alternate template (?view=card). */
(function () {
  var KEY = 'pj_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('pj:wishlist:change'));
  }
  function has(handle) { return read().indexOf(handle) > -1; }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    write(list);
    return i === -1;
  }
  window.PJWishlist = { read: read, has: has, toggle: toggle };

  /* Heart toggle button (on cards + product page) */
  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', class extends HTMLElement {
      connectedCallback() {
        this.handle = this.getAttribute('handle');
        this.btn = this.querySelector('button');
        if (!this.btn || !this.handle) return;
        this._sync = this.sync.bind(this);
        this.btn.addEventListener('click', this.onClick.bind(this));
        document.addEventListener('pj:wishlist:change', this._sync);
        this.sync();
      }
      disconnectedCallback() { document.removeEventListener('pj:wishlist:change', this._sync); }
      onClick(e) { e.preventDefault(); e.stopPropagation(); toggle(this.handle); }
      sync() {
        var active = has(this.handle);
        this.classList.toggle('is-active', active);
        this.btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        this.btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
        var label = this.querySelector('.wishlist-button__label');
        if (label) label.textContent = active ? 'Saved' : 'Save';
      }
    });
  }

  /* Header count bubble */
  if (!customElements.get('wishlist-count')) {
    customElements.define('wishlist-count', class extends HTMLElement {
      connectedCallback() { this._u = this.update.bind(this); document.addEventListener('pj:wishlist:change', this._u); this.update(); }
      disconnectedCallback() { document.removeEventListener('pj:wishlist:change', this._u); }
      update() { var n = read().length; this.textContent = n; this.toggleAttribute('hidden', n === 0); }
    });
  }

  /* Wishlist page renderer */
  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.empty = this.querySelector('[data-wishlist-empty]');
        this.loading = this.querySelector('[data-wishlist-loading]');
        this._r = this.render.bind(this);
        document.addEventListener('pj:wishlist:change', this._r);
        this.render();
      }
      disconnectedCallback() { document.removeEventListener('pj:wishlist:change', this._r); }
      render() {
        var handles = read();
        if (!handles.length) {
          if (this.grid) this.grid.innerHTML = '';
          if (this.empty) this.empty.hidden = false;
          if (this.loading) this.loading.hidden = true;
          return;
        }
        if (this.empty) this.empty.hidden = true;
        if (this.loading) this.loading.hidden = false;
        var self = this;
        Promise.all(handles.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '?view=card')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; });
        })).then(function (cards) {
          if (self.loading) self.loading.hidden = true;
          var html = cards.filter(Boolean).map(function (c) { return '<li class="grid__item">' + c + '</li>'; }).join('');
          if (self.grid) self.grid.innerHTML = html;
          if (!html && self.empty) self.empty.hidden = false;
        });
      }
    });
  }
})();
